<template>
  <div>
    <transition name="myself-drawer-fade">
      <div class="drawer_father" v-if="drawerFlag">
        <div class="drawer_son" @click.stop :style="{backgroundColor: backgroundColorForSon}">
          <div class="close_icon ZHIHUISHU_QZMD" @click="$emit('hideMask')">
            <img src="//image.zhihuishu.com/zhs_yufa_150820/ablecommons/zhangying/202109/5d68bd00c9ab4fb18a3511c328a76a65.png" alt="关闭">
          </div>
          <slot></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    drawerFlag: {
      type: Boolean,
      default: false
    },
    backgroundColorForSon: {
      type: String,
      default: "#FFF"
    }
  }
}
</script>

<style lang="scss" scoped>
.drawer_father {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9;
  overflow: auto;
  .drawer_son {
    width: 100%;
    height: 80vh;
    position: absolute;
    bottom: 0;
    border-radius: 20px 20px 0 0;
    .close_icon {
      width: 42px;
      height: 42px;
      position: absolute;
      top: -54px;
      right: 36px;
      color: #fff;
      img {
        width: inherit;
        height: inherit;
        cursor: pointer;
      }
    }
  }
}
.myself-drawer-fade-enter-active {
  animation: drawer-fadein 0.4s;
  .drawer_son {
    animation: drawer-zoom 0.4s;
  }
}
  
.myself-drawer-fade-leave-active {
  animation: drawer-fadeout 0.4s;
  .drawer_son {
    animation: drawer-out 0.4s;
  }
}
  
@keyframes drawer-fadein {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
  
@keyframes drawer-fadeout {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}
  
@keyframes drawer-zoom {
  0% {
    transform: translate3d(0, 100% , 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
  
@keyframes drawer-out {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(0, 100%, 0);
  }
}
    
</style>
